// extracted by mini-css-extract-plugin
export default {"link":"DownloadModal_link__dY+9h"};